export enum TipoAcaoModal {
	Subir = 'subir',
	Excluir = 'excluir',
}
